<template>
  <div>
      <el-breadcrumb class="bread" separator-class="el-icon-arrow-right" activi>
      <el-breadcrumb-item>
        <span class="title">报表</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <span class="title">费用报表</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="conditon">
      <div class="fley">
      <span class="screen">
        站点筛选
        <i class="el-icon-caret-bottom"></i>
      </span>
      <span class="screen" style="margin-right:10px">开始时间</span>
      <!-- 开始日期和时间 -->
      <div class="block">
        <!-- 开始日期 -->
        <el-date-picker
          v-model="startDate"
          :picker-options="pickerOptionsStart"
          @change="changeStart"
          value-format="timestamp"
          type="date"
          placeholder="开始日期"
          format="yyyy/MM/dd"
          style="width:140px;height:30px;margin-right:10px"
        ></el-date-picker>
        <!-- 开始时间 -->
        <el-time-picker
          style="width:120px;height:30px;"
          v-model="startTime"
          placeholder="开始时间"
          format="HH:mm"
          value-format="HH:mm"
          :picker-options="{selectableRange:`00:00:00-${endTime ? endTime+':00' : '23:59:59'}`}"
        ></el-time-picker>
      </div>
      <span class="screen" style="margin-left:23px;margin-right:10px">结束时间</span>
      <!-- 结束日期和时间 -->
      <div class="block">
        <!-- 结束日期 -->
        <el-date-picker
          v-model="endDate"
          format="yyyy/MM/dd "
          value-format="timestamp"
          :picker-options="pickerOptionsEnd"
          @change="changeEnd"
          type="date"
          placeholder="结束日期"
          style="width:140px;height:30px;margin-right:10px"
        ></el-date-picker>
        <!-- 结束时间 -->
        <el-time-picker
          style="width:120px;height:30px;"
          v-model="endTime"
          placeholder="结束时间"
          format="HH:mm"
          value-format="HH:mm"
          :picker-options="{selectableRange:`${startTime ? startTime + ':00' : '00:00:00'}-23:59:59`}"
        ></el-time-picker>
      </div>
      <span class="screen" style="margin-left:23px;margin-right:10px">选择预设时间</span>
      <el-select
        v-model="value"
        placeholder="请选择"
        style="width:140px;height:30px;margin-right:10px"
        @change="currentSel"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div class="right">
        <el-button plain type="primary" class="button">
          <span>查询</span>
        </el-button>
        <el-button plain type="primary" class="button">
          <span>导出</span>
        </el-button>
        <el-button plain type="primary" class="button">
          <span>打印</span>
        </el-button>
      </div>
      </div>
      <!--  -->
    <ul class="parent">
      <ul class="left">
        <li>
            <span class="iconfont" style="color:#FF5577;font-size:10px">&#xe655;</span>
        <div class="content">
          <div class="cricle cricle1">
            <span class="iconfont" style="color:white;font-size:23px;">&#xe655;</span>
          </div>
          <div class="text">
            <span>5624.189</span>
            <span>总用电量(kWh)</span>
          </div>
        </div>
        </li>
        <li>
           <span class="iconfont" style="color:#FF5577;font-size:10px">&#xe655;</span>
        <div class="myChart" id="bar_dv" ref="chart" :style="{width: '754px', height: '350px'}"></div>
        </li>
        <li>
          <span class="iconfont" style="color:#BDDAFF;font-size:10px">&#xe617;</span>
        <div class="content">
          <div class="cricle cricle1" style="background:#4E84FF">
            <span class="iconfont" style="color:white;font-size:23px;">&#xe617;</span>
          </div>
          <div class="text">
            <span>308.299</span>
            <span>总用汽量(T)</span>
          </div>
        </div>
        </li>
        <li>
             <span class="iconfont" style="color:#FF5577;font-size:10px">&#xe655;</span>
        <div class="myChart" id="bar_dv3" ref="chart3" :style="{width: '754px', height: '350px'}"></div>
        </li>
      </ul>
      <ul class="right">
        <li>
          <span class="iconfont" style="color:#FF5577;font-size:10px">&#xe655;</span>
        <div class="content">
          <div class="cricle cricle2">
            <span class="iconfont" style="color:white;font-size:23px;">&#xe645;</span>
          </div>
          <div class="text">
            <span>5624.189</span>
            <span>总用电费(￥)</span>
          </div>
        </div>
        </li>
        <li>
             <span class="iconfont" style="color:#FF5577;font-size:10px">&#xe655;</span>
        <div class="myChart" id="bar_dv2" ref="chart2" :style="{width: '754px', height: '350px'}"></div>
        </li>
        <li>
          <span class="iconfont" style="color:#FF5577;font-size:10px">&#xe655;</span>
        <div class="content">
          <div class="cricle cricle2">
            <span class="iconfont" style="color:white;font-size:23px;">&#xe645;</span>
          </div>
          <div class="text">
            <span>5624.189</span>
            <span>总用电费(￥)</span>
          </div>
        </div>
        </li>
        <li>
              <span class="iconfont" style="color:#FF5577;font-size:10px">&#xe655;</span>
        <div class="myChart" id="bar_dv4" ref="chart4" :style="{width: '754px', height: '350px'}"></div>
        </li>
      </ul>
    </ul>
    </div>
    
    </div>
</template>

<script>

  const option  = {
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
  grid: {
    left: "8%",
    right: "0",
    bottom: "1%",
    containLabel: true,
  },
  legend: {
    // orient: "vertical",
    icon: "circle",
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: "14",
    },
    itemGap: 100, // 设置legend的间距
    itemWidth: 30, // 设置宽度
    itemHeight: 14, // 设置高度
    data: ["早班电量", "中班电量", "晚班电量"],
    formatter: function (name) {
      var index = 0;
      var labels = ["早班电量", "中班电量", "晚班电量"];
      var counts = [1.542, 1.021, 0.894];
      labels.forEach(function (value, i) {
        if (value == name) {
          index = i;
        }
      });
      return counts[index] + "¥/kWh\n" + name;
    },
  },
  series: [
    {
      name: "用量",
      type: "pie",
      selectedMode: "false",
      radius: [40, "56%"],
      center: ["50%", "62%"],
      label: {
       
        formatter: "{b}\n\n{d}%\n\n{c}kWh",
        fontSize: "12",
      },
      labelLine: {
        //引导线设置
        normal: {
          show: true, //引导线显示
          // smooth: 0.2,//平滑程度
          lineStyle: {
            length: 20, //引导线的长度
            width: 2,
            type: "dotted",
          },
        },
      },
      data: [
        {
          value: 3453.945,
          name: "早班电量",
          itemStyle: { color: "#FECB5F", fontSize: 12 },
        },
        {
          value: 678.876,
          name: "中班电量",
          itemStyle: { color: "#4FC953", fontSize: 12 },
        },
        {
          value: 2876.943,
          name: "晚班电量",
          itemStyle: { color: "#4D83FF", fontSize: 12 },
        },
      ],
    },
    {
      name: "价格",
      type: "pie",
      radius: ["65%", "75%"],
      center: ["50%", "62%"],
      label: {
        formatter: "{b}：\n{c}￥\n{d}%",
        color: "#666",
        fontSize: "14",
      },
      labelLine: {
        //引导线设置
        normal: {
          show: true, //引导线显示
          // smooth: 0.2,//平滑程度
          lineStyle: {
            length: 20, //引导线的长度
            width: 2,
            type: "dotted",
          },
        },
      },
      
    },
  ],
};
  const option2 = {

  tooltip: {
    trigger: "axis",
    formatter: function (datas) {
      var res = datas[0].name + "<br/>";
      res +=
       '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF5C65"></span>';
      res += datas[0].seriesName + "：" + datas[0].value + "kWh" + "<br/>";
      res +=
        '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FEC54A"></span>';
      res +=
        datas[1].seriesName + "：" + Math.abs(datas[1].value) + "kWh" + "<br/>";
      res +=
        '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#4FC953"></span>';
      res += datas[2].seriesName + "：" + datas[2].value + "kWh" + "<br/>";
      res +=
        '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#578AFF"></span>';
      res += datas[3].seriesName + "：" + datas[3].value + "元" + "<br/>";

      return res;
    },
    axisPointer: {
      type: "none",
      crossStyle: {
        color: "#999",
      },
      label: {},
    },
  },
  toolbox: {
    feature: {
      saveAsImage: { show: true },
    },
  },
  legend: {
    data: ["早班", "午班", "晚班"],
    icon: "circle",
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: "14",
    },
    itemGap: 60, // 设置legend的间距
    itemWidth: 30, // 设置宽度
    itemHeight: 14, // 设置高度
    formatter: function (name) {
      var index = 0;
      var labels = ["早班", "午班", "晚班",];
      var counts = ["(00:00-12:00)", "(12:00-18:00)", "(18:00-00:00)",];
      labels.forEach(function (value, i) {
        if (value == name) {
          index = i;
        }
      });
      return counts[index] + "\n\n" + name;
    },
  },
  xAxis: [
    {
      type: "category",
      data: [
        "00:00",
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00", 
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00",

      ],
      axisPointer: {
        type: "shadow",
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "(kWh)",
      splitLine: {
        //网格线
        show: true,
        lineStyle: {
          type: "dashed",
          color: "#E5E5E5",
        },
      },
      interval: 300,
      axisLabel: {
        formatter: function (value) {
          return value;
        },
      },
    },
    {
      type: "value",
      splitLine: {
        //网格线
        show: true,
        lineStyle: {
          type: "dashed",
          color: "#E5E5E5",
        },
      },
      interval: 300,
      axisLabel: {
        formatter: function (value) {
          return value;
        },
      },
    },
  ],
  series: [
    {
      name: "早班",
      type: "bar",
      stack: "one",
      itemStyle: {
        normal: {
          color: "##FDCB5F",
          barBorderRadius: [0,0, 0, 0],
        },
      },
      barWidth: 15, //柱子宽度
      data: [
        900,
        533,
        565,
        343,
        652,
        423,
        865,
        845,
        853,
        763,
        534,
        765,
        354,
        876,
        765,
        676,
      ],
    },
    {
      name: "午班",
      type: "bar",
      stack: "one",
      itemStyle: {
        normal: {
          color: "##4FC953",
          barBorderRadius: [0, 0, 0,0],
        },
      },
      barWidth: 15, //柱子宽度
      data: [
        632,
        432,
        313,
        324,
        432,
        432,
        423,
        123,
        322,
        123,
        321,
        321,
        231,
        265,
        311,
        267,
      ],
    },
    {
      name: "晚班",
      type: "bar",
      stack: "one",
      itemStyle: {
        normal: {
          color: "#4D83FF",
          barBorderRadius: [0, 0, 0,0],
        },
      },
      barWidth: 15, //柱子宽度
      data: [
        143,
        198,
        154,
        165,
        156,
        167,
        132,
        176,
        156,
        187,
        156,
        146,
        165,
        165,
        188,
        134,
      ],
    },
    {
       
      type: "line",
      stack: "two",
      itemStyle: {
        normal: {
          color: "#578AFF",
          lineStyle: {
            width: 3,
          },
        },
      },
      
    },
  ],
};
  const option4 = {
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
  grid: {
    left: "8%",
    right: "0",
    bottom: "1%",
    containLabel: true,
  },
  legend: {
    // orient: "vertical",
    icon: "circle",
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: "14",
    },
    itemGap: 100, // 设置legend的间距
    itemWidth: 30, // 设置宽度
    itemHeight: 14, // 设置高度
    data: ["早班电量", "中班电量", "晚班电量"],
    formatter: function (name) {
      var index = 0;
      var labels = ["早班电量", "中班电量", "晚班电量"];
      var counts = [1.542, 1.021, 0.894];
      labels.forEach(function (value, i) {
        if (value == name) {
          index = i;
        }
      });
      return counts[index] + "¥/kWh\n" + name;
    },
  },
  series: [
    {
      name: "用量",
      type: "pie",
      selectedMode: "false",
      radius: [40, "56%"],
      center: ["50%", "62%"],
      label: {
       
        formatter: "{b}\n\n{d}%\n\n{c}kWh",
        fontSize: "12",
      },
      labelLine: {
        //引导线设置
        normal: {
          show: true, //引导线显示
          // smooth: 0.2,//平滑程度
          lineStyle: {
            length: 20, //引导线的长度
            width: 2,
            type: "dotted",
          },
        },
      },
      data: [
        {
          value: 3453.945,
          name: "早班电量",
          itemStyle: { color: "#FECB5F", fontSize: 12 },
        },
        {
          value: 678.876,
          name: "中班电量",
          itemStyle: { color: "#4FC953", fontSize: 12 },
        },
        {
          value: 2876.943,
          name: "晚班电量",
          itemStyle: { color: "#4D83FF", fontSize: 12 },
        },
      ],
    },
    {
      name: "价格",
      type: "pie",
      radius: ["65%", "75%"],
      center: ["50%", "62%"],
      label: {
        formatter: "{b}：\n{c}￥\n{d}%",
        color: "#666",
        fontSize: "14",
      },
      labelLine: {
        //引导线设置
        normal: {
          show: true, //引导线显示
          // smooth: 0.2,//平滑程度
          lineStyle: {
            length: 20, //引导线的长度
            width: 2,
            type: "dotted",
          },
        },
      },
      
    },
  ],
};
  const option3 = {
  // ----  标题 -----
  title: {
    text: '主标题',
    textStyle: {
      color: 'red'
    },
    subtext: '副标题',
    subtextStyle: {
      color: 'blue'
    },
    padding: [0, 0, 10, 100]  // 位置
  },
  // ---- legend ----
  legend: {
    type: 'plain',  // 图列类型，默认为 'plain'
    top: '1%',  // 图列相对容器的位置 top\bottom\left\right
    selected: {
      // '销量': true  // 图列选择，图形加载出来会显示选择的图列，默认为true
    },
    textStyle: {  // 图列内容样式
      color: '#fff',  // 字体颜色
      backgroundColor: 'black'  // 字体背景色
    },
    tooltip: {  // 图列提示框，默认不显示
      show: true,
      color: 'red'  
    },
    data: [   // 图列内容
      {
        name: '销量',
        icon: 'circle',
        textStyle: {
          color: 'red',  // 单独设置某一个图列的颜色
          backgroundColor: '#fff' // 单独设置某一个图列的字体背景色
        }
      }
    ]
  },
  // ---  提示框 ----
  tooltip: {
    show: true,   // 是否显示提示框，默认为true
    trigger: 'item', // 数据项图形触发
    axisPointer: {   // 指示样式
      type: 'shadow',
      axis: 'auto'
    },
    padding: 5,
    textStyle: {   // 提示框内容的样式
      color: '#fff'  
    }
  },
  // ---- gird区域 ---
  gird: {
    show: false,    // 是否显示直角坐标系网格
    top: 80,  // 相对位置 top\bottom\left\right
    containLabel: false, // gird 区域是否包含坐标轴的刻度标签
    tooltip: {
      show: true,
      trigger: 'item',   // 触发类型
      textStyle: {
        color: '#666'
      }
    }
  },
  //  ------  X轴 ------
  xAxis: {
    show: true,  // 是否显示
    position: 'bottom',  // x轴的位置
    offset: 0, // x轴相对于默认位置的偏移
    type: 'category',   // 轴类型， 默认为 'category'
    name: '月份',    // 轴名称
    nameLocation: 'end',  // 轴名称相对位置
    nameTextStyle: {   // 坐标轴名称样式
      color: 'red',
      padding: [5, 0, 0, -5]
    },
    nameGap: 15, // 坐标轴名称与轴线之间的距离
    nameRotate: 0,  // 坐标轴名字旋转
    axisLine: {       // 坐标轴 轴线
      show: true,  // 是否显示
      symbol: ['none', 'arrow'],  // 是否显示轴线箭头
      symbolSize: [8, 8], // 箭头大小
      symbolOffset: [0, 7],  // 箭头位置
      // ------   线 ---------
      lineStyle: {
        color: 'blue',
        width: 1,
        type: 'solid'
      }
    },
    axisTick: {    // 坐标轴 刻度
      show: true,  // 是否显示
      inside: true,  // 是否朝内
      length: 3,     // 长度
      lineStyle: {   // 默认取轴线的样式
        color: 'red',
        width: 1,
        type: 'solid'
      }
    },
    axisLabel: {    // 坐标轴标签
      show: true,  // 是否显示
      inside: false, // 是否朝内
      rotate: 0, // 旋转角度
      margin: 5, // 刻度标签与轴线之间的距离
      color: 'red'  // 默认取轴线的颜色 
    },
    splitLine: {    // gird区域中的分割线
      show: false,  // 是否显示
      lineStyle: {
        // color: 'red',
        // width: 1,
        // type: 'solid'
      }
    },
    splitArea: {    // 网格区域
      show: false  // 是否显示，默认为false
    },
    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
  },
  //   ------   y轴  ----------
  yAxis: {
    show: true,  // 是否显示
    position: 'left', // y轴位置
    offset: 0, // y轴相对于默认位置的偏移
    type: 'value',  // 轴类型，默认为 ‘category’
    name: '销量',   // 轴名称
    nameLocation: 'end', // 轴名称相对位置value
    nameTextStyle: {    // 坐标轴名称样式
      color: '#fff',
      padding: [5, 0, 0, 5]  // 坐标轴名称相对位置
    },
    nameGap: 15, // 坐标轴名称与轴线之间的距离
    nameRotate: 270,  // 坐标轴名字旋转

    axisLine: {    // 坐标轴 轴线
      show: true,  // 是否显示
      //  -----   箭头 -----
      symbol: ['none', 'arrow'],  // 是否显示轴线箭头
      symbolSize: [8, 8],  // 箭头大小
      symbolOffset: [0, 7], // 箭头位置

      // ----- 线 -------
      lineStyle: {
        color: 'blue',
        width: 1,
        type: 'solid'
      }
    },
    axisTick: {      // 坐标轴的刻度
      show: true,    // 是否显示
      inside: true,  // 是否朝内
      length: 3,      // 长度
      lineStyle: {
        color: 'red',  // 默认取轴线的颜色
        width: 1,
        type: 'solid'
      }
    },
    axisLabel: {      // 坐标轴的标签
      show: true,    // 是否显示
      inside: false,  // 是否朝内
      rotate: 0,     // 旋转角度
      margin: 8,     // 刻度标签与轴线之间的距离
      color: 'red',  // 默认轴线的颜色
    },
    splitLine: {    // gird 区域中的分割线
      show: true,   // 是否显示
      lineStyle: {
        color: '#666',
        width: 1,
        type: 'dashed'
      }
    },
    splitArea: {     // 网格区域
      show: false   // 是否显示，默认为false
    }
  },
  //  -------   内容数据 -------
  series: [
    {
      name: '销量',      // 序列名称
      type: 'bar',      // 类型
      legendHoverLink: true,  // 是否启用图列 hover 时的联动高亮
      label: {   // 图形上的文本标签
        show: false,
        position: 'insideTop', // 相对位置
        rotate: 0,  // 旋转角度
        color: '#eee'
      },
      itemStyle: {    // 图形的形状
        color: 'blue',
        barBorderRadius: [18, 18, 0 ,0]
      },
      barWidth: 20,  // 柱形的宽度
      barCategoryGap: '20%',  // 柱形的间距
      data: [3000, 4000, 4200, 4500, 6000, 5600, 4500, 5020, 4500, 5400, 4300, 1200]
    }
  ]
};

export default {
  name: "shiftReport",
  data() {
    return {};
  },
   mounted() {
    this.$nextTick(() => {
      //   //echarts图表
      this.drawLine();
    });
  },
  methods:{
    currentSel(selVal) {
      //获取下拉菜单选中的值
      console.log(selVal);
    },
    drawLine() {
            var echarts = require("echarts");
      var bar_dv  = this.$refs.chart;
      var bar_dv2 = this.$refs.chart2;
      var bar_dv3 = this.$refs.chart3;
      var bar_dv4 = this.$refs.chart4;
      echarts.init(bar_dv) .setOption(option, true);
      echarts.init(bar_dv2).setOption(option2, true);
      echarts.init(bar_dv3).setOption(option3, true);
      echarts.this(bar_dv4).setOption(option4, true);
    },
    changeStart() {
     
      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          if (this.startDate) {
            return time.getTime() < this.startDate;
          } else {
            // return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      });
    },
    
  },
  components: {},
};
</script>

<style lang='scss' scoped>
.fley{
  display: flex;
   flex-wrap: wrap;
   justify-content:space-around;
   
}


.cricle {
        width: 49px;
        height: 49px;
        background: rgba(254, 197, 74, 1);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 43px;
      }
      .cricle2 {
        background: rgba(79, 201, 83, 1);
      }
      .cricle3 {
        background: rgba(255, 89, 98, 1);
      }
.bread {
  background: white;
  height: 50px;
  line-height: 50px;
  padding-left: 34px;
  margin-bottom: 10px;
}

 

div {
  
  color: black;
}
</style>
